import { CancelToken } from "axios";
import { authAxios as axios } from "shared-auth";
import queryString from "query-string";

import {
  ISelfTapeRequestInviteListFilterParams,
  ISelfTapeRequestsListFilterParams,
} from "shared/models/api";
import {
  ISelfTapeRequest,
  ISelfTapeRequestInviteList,
  ISelfTapeRequestsList,
  ISubmission,
  ISubmissionDetails,
} from "shared/models/selfTapeRequest";

import config from "config/global";

class SelfTapeRequestService {
  private readonly url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async getSelfTapeRequest(
    selfTapeRequestId: string,
    cancellationToken?: CancelToken
  ): Promise<ISelfTapeRequest> {
    return this.getRequest(
      `${this.url}/selftaperequest/${selfTapeRequestId}`,
      cancellationToken
    );
  }

  public async getSelfTapeRequestForPerformerByPerformerRequestId(
    performerRequestId: string,
    cancellationToken?: CancelToken
  ): Promise<ISelfTapeRequest> {
    return this.getRequest(
      `${this.url}/submission/performerrequest/${performerRequestId}`,
      cancellationToken
    );
  }

  public async findSelfTapeRequests(
    params: ISelfTapeRequestsListFilterParams,
    cancellationToken?: CancelToken
  ): Promise<ISelfTapeRequestsList> {
    const response = await axios(`${this.url}/selftaperequest`, {
      params,
      paramsSerializer: queryString.stringify,
      cancelToken: cancellationToken,
    });

    return response.data;
  }

  public async findSelfTapeRequestInvitations(
    selfTapeRequestId: string,
    params: ISelfTapeRequestInviteListFilterParams,
    cancellationToken?: CancelToken
  ): Promise<ISelfTapeRequestInviteList> {
    const response = await axios(
      `${this.url}/selftaperequest/${selfTapeRequestId}/invite`,
      {
        params,
        paramsSerializer: queryString.stringify,
        cancelToken: cancellationToken,
      }
    );

    return response.data;
  }

  public async createSelftapeSubmissionByPerformerRequestId(
    performerRequestId: string,
    submissionDetails: ISubmissionDetails
  ): Promise<ISubmission> {
    const response = await axios(
      `${this.url}/submission/performerrequest/${performerRequestId}`,
      {
        method: "post",
        data: submissionDetails,
      }
    );

    return response.data;
  }

  public async publishSelftapeSubmissionByPerformerRequestId(
    performerRequestId: string,
    submissionId: string
  ): Promise<ISubmission> {
    const response = await axios(
      `${this.url}/submission/performerrequest/${performerRequestId}/${submissionId}/publish`,
      {
        method: "post",
      }
    );

    return response.data;
  }

  private async getRequest(
    getUrl: string,
    cancellationToken?: CancelToken
  ): Promise<ISelfTapeRequest> {
    const response = await axios(getUrl, {
      cancelToken: cancellationToken,
    });
    return response.data;
  }
}

export const selfTapesApiUrl = config.selfTapesApiUrl;

export default new SelfTapeRequestService({
  url: selfTapesApiUrl,
});
